module.exports = __webpack_public_path__ + "static/media/game-preview.6f326605.png";